import { render, staticRenderFns } from "./ScannedVoterUploadForm.vue?vue&type=template&id=270e116e"
import script from "./ScannedVoterUploadForm.vue?vue&type=script&lang=js"
export * from "./ScannedVoterUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports